import { useEffect, useState } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import api from "../lib/api";

const MAX_ATTEMPTS = 8;
const INTERVAL_MS = 2500;

export default function GuideMerci() {
    const { slug } = useParams();
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const sessionId = params.get("session_id");
    const [status, setStatus] = useState("checking");
    const [message, setMessage] = useState("Vérification du paiement…");
    const [attempts, setAttempts] = useState(0);

    useEffect(() => {
        if (!sessionId) { navigate(`/guides/${slug}`); return; }
        let cancelled = false;

        const poll = async (n) => {
            try {
                const r = await api.get(`/checkout/status/${sessionId}`);
                if (cancelled) return;
                if (r.data.payment_status === "paid") {
                    setStatus("paid");
                    setMessage("Paiement confirmé. Redirection vers votre guide…");
                    if (r.data.email) localStorage.setItem("cp_email", r.data.email);
                    setTimeout(() => navigate(`/guides/${slug}`, { replace: true }), 1500);
                    return;
                }
                if (r.data.status === "expired") {
                    setStatus("expired");
                    setMessage("Session expirée. Merci de réessayer.");
                    return;
                }
                if (n >= MAX_ATTEMPTS) {
                    setStatus("timeout");
                    setMessage("Le paiement prend un peu plus de temps qu'attendu. Revenez dans quelques minutes via la page du guide avec votre email.");
                    return;
                }
                setMessage("Paiement en cours de traitement…");
                setAttempts(n + 1);
                setTimeout(() => poll(n + 1), INTERVAL_MS);
            } catch {
                if (n < MAX_ATTEMPTS) setTimeout(() => poll(n + 1), INTERVAL_MS);
                else setStatus("error");
            }
        };
        poll(0);
        return () => { cancelled = true; };
    }, [sessionId, slug, navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-cp-ivoire px-6 py-20" data-testid="guide-merci">
            <div className="max-w-xl text-center">
                <p className="cp-tiny text-cp-terre mb-6">Merci</p>
                <h1 className="cp-serif text-5xl md:text-7xl leading-[0.9] text-cp-encre mb-8">
                    {status === "paid" ? "Paiement" : "Un instant…"}<br />
                    <em className="cp-display-italic text-cp-foret">{status === "paid" ? "confirmé" : "vérification"}.</em>
                </h1>
                <p className="cp-serif italic text-xl text-cp-gris mb-8">{message}</p>
                {status !== "paid" && attempts > 0 && (
                    <p className="cp-tiny text-cp-gris/60">Tentative {attempts} / {MAX_ATTEMPTS}</p>
                )}
            </div>
        </div>
    );
}
